import { SSOStages, ActionTypes } from '../constants';
import { getQueryParams } from '../utils';

export function getSSOStage() {
  const qParams = getQueryParams(window.location.href);
  const { PRE_SSO_AUTH, POST_SSO_AUTH } = SSOStages;
  return !(qParams && qParams.session_state && qParams.code)
    ? PRE_SSO_AUTH
    : POST_SSO_AUTH;
}

export function setSSOStage(ssoStage) {
  return {
    type: ActionTypes.SET_SSO_STAGE,
    payload: { ssoStage },
  };
}

export function setError(errorMessage) {
  return {
    type: ActionTypes.SET_ERROR,
    payload: { errorMessage },
  };
}

export function initApp() {
  const ssoStage = getSSOStage();
  const { HANDLE_POST_SSO_STAGE, HANDLE_PRE_SSO_STAGE } = ActionTypes;
  const type =
    ssoStage === SSOStages.POST_SSO_AUTH
      ? HANDLE_POST_SSO_STAGE
      : HANDLE_PRE_SSO_STAGE;
  return { type, payload: { ssoStage } };
}

export function fetchSSODetails(companyId = null) {
  return {
    type: ActionTypes.FETCH_SSO_ENDPOINT,
    payload: {
      companyId,
    },
  };
}

export function doSSOAuthentication(store) {
  const { ssoExpressEndpointUrl } = store.sso;
  return {
    type: ActionTypes.DO_SSO_AUTHENTICATION,
    payload: {
      endpoint: ssoExpressEndpointUrl,
    },
  };
}

export function loginToCommandCenter(accessToken) {
  return {
    type: ActionTypes.LOGIN_TO_COMMAND_CENTER,
    payload: { accessToken },
  };
}

export function handleSuccessfulLogin(sessionState) {
  return {
    type: ActionTypes.REDIRECT_TO_COMMAND_CENTER,
    payload: { sessionState },
  };
}

export function handleLoginError(error) {
  return {
    type: ActionTypes.HANDLE_COMMAND_CENTER_LOGIN_FAILURE,
    payload: { error },
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js